import React from 'react';
import { Icon, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { ClippedContent } from 'dyl-components';

const taskFormat = (name, taskName, contact_id) => {
    return <>
       <div style={{display: 'block'}}><Header as='h5'>{name} Task Note</Header></div>
       <Link to={`/contact/${contact_id}/tasks`} ><ClippedContent><Icon className="fa-solid fa-clipboard-check" /> {taskName} </ClippedContent></Link> 
    </>
}

const noteType = (type, taskName="N/A", contact_id, sub_type ) => {
    let noteType;
    switch (type){
        case "Call":
            if (sub_type === "inbound" || sub_type === "outbound") {
                noteType = (
                    <Header as="h5" style={{ textTransform: "capitalize" }}>
                        <Icon
                            className={`fa-solid fa-phone-${
                                sub_type === "inbound"
                                    ? "arrow-down-left"
                                    : "arrow-up-right"
                            }`}
                            size="small"
                            style={{ marginRight: 4 }}
                        />
                        {sub_type} Call Note
                    </Header>
                );
            } else noteType = taskFormat("Call", taskName, contact_id);
            break;
        case "Email":
            noteType = taskFormat("Email", taskName, contact_id);
            break;
        case "Text":
            noteType = taskFormat("Text", taskName, contact_id);
            break;
        case "To-Do":
            noteType = taskFormat("To Do", taskName, contact_id);
            break;
        case "log_call":
            noteType =  <><Header as='h5' color='primary'><Icon className="fas fa-clock-rotate-left" size='small' style={{marginRight: 0}} /> Call Activity Note</Header></>;
            break;
        case "log_email":
            noteType =  <><Header as='h5' color='primary'><Icon className="fas fa-clock-rotate-left" size='small' style={{marginRight: 0}} /> Email Activity Note</Header></>;
            break;
        case "log_text":
            noteType =  <><Header as='h5' color='primary'><Icon className="fas fa-clock-rotate-left" size='small' style={{marginRight: 0}} /> Text Activity Note</Header></>;
            break;
        case "general":
            noteType = <><Header as='h5'>General Note</Header></>;
            break;

        case "call_activity":
            noteType = (
                <Header as="h5" style={{ textTransform: "capitalize" }} color='primary'>
                    <Icon
                        className="fa-solid fa-clock-rotate-left"
                        style={{ marginRight: 4 }}
                    />
                    Call Activity Note
                </Header>
            )
            break;
        case "email_activity":
            noteType = (
                <Header as="h5" style={{ textTransform: "capitalize" }} color='primary'>
                    <Icon
                        className="fa-solid fa-clock-rotate-left"
                        style={{ marginRight: 4 }}
                    />
                    Email Activity Note
                </Header>
            )
            break;
        case "text_activity":
            noteType = (
                <Header as="h5" style={{ textTransform: "capitalize" }} color='primary'>
                    <Icon
                        className="fa-solid fa-clock-rotate-left"
                        style={{ marginRight: 4 }}
                    />
                    Text Activity Note
                </Header>
            )
            break;

        default:
            noteType = <><Header as='h5'>General Note</Header></>;
    }
    return noteType;
}

export default noteType;